// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__Bytes from "melange/bytes.js";
import * as Stdlib__Int32 from "melange/int32.js";
import * as Stdlib__Int64 from "melange/int64.js";

function Make(T) {
  const $$enum = function (e) {
    return {
      TAG: /* Enum */ 0,
      _0: e
    };
  };
  const message = function (m) {
    return {
      TAG: /* Message */ 1,
      _0: m
    };
  };
  const some = function (v) {
    return Caml_option.some(v);
  };
  const default_bytes = function (v) {
    return Stdlib__Bytes.of_string(v);
  };
  const repeated = function (param) {
    return {
      TAG: /* Repeated */ 3,
      _0: param[0],
      _1: param[1],
      _2: param[2]
    };
  };
  const map = function (param) {
    return {
      TAG: /* Map */ 4,
      _0: param[0],
      _1: param[1]
    };
  };
  const basic = function (param) {
    return {
      TAG: /* Basic */ 0,
      _0: param[0],
      _1: param[1],
      _2: param[2]
    };
  };
  const basic_req = function (param) {
    return {
      TAG: /* Basic_req */ 2,
      _0: param[0],
      _1: param[1]
    };
  };
  const basic_opt = function (param) {
    return {
      TAG: /* Basic_opt */ 1,
      _0: param[0],
      _1: param[1]
    };
  };
  const oneof = function (s) {
    return {
      TAG: /* Oneof */ 5,
      _0: s
    };
  };
  const oneof_elem = function (param) {
    return {
      TAG: /* Oneof_elem */ 0,
      _0: param[0],
      _1: param[1],
      _2: param[2]
    };
  };
  const $caret$colon$colon = function (a, b) {
    return {
      TAG: /* Cons */ 1,
      _0: a,
      _1: b
    };
  };
  const nil_ext = function (extension_ranges) {
    return {
      TAG: /* Nil_ext */ 0,
      _0: extension_ranges
    };
  };
  const show = function (param) {
    if (!/* tag */ (typeof param === "number" || typeof param === "string")) {
      if (param.TAG === /* Enum */ 0) {
        return "Enum";
      } else {
        return "Message";
      }
    }
    switch (param) {
      case /* Double */ 0 :
        return "Double";
      case /* Float */ 1 :
        return "Float";
      case /* Int32 */ 2 :
        return "Int32";
      case /* UInt32 */ 3 :
        return "UInt32";
      case /* SInt32 */ 4 :
        return "SInt32";
      case /* Fixed32 */ 5 :
        return "Fixed32";
      case /* SFixed32 */ 6 :
        return "SFixed32";
      case /* Int32_int */ 7 :
        return "Int32_int";
      case /* UInt32_int */ 8 :
        return "UInt32_int";
      case /* SInt32_int */ 9 :
        return "SInt32_int";
      case /* Fixed32_int */ 10 :
        return "Fixed32_int";
      case /* SFixed32_int */ 11 :
        return "SFixed32_int";
      case /* UInt64 */ 12 :
        return "UInt64";
      case /* Int64 */ 13 :
        return "Int64";
      case /* SInt64 */ 14 :
        return "SInt64";
      case /* Fixed64 */ 15 :
        return "Fixed64";
      case /* SFixed64 */ 16 :
        return "SFixed64";
      case /* UInt64_int */ 17 :
        return "UInt64_int";
      case /* Int64_int */ 18 :
        return "Int64_int";
      case /* SInt64_int */ 19 :
        return "SInt64_int";
      case /* Fixed64_int */ 20 :
        return "Fixed64_int";
      case /* SFixed64_int */ 21 :
        return "SFixed64_int";
      case /* Bool */ 22 :
        return "Bool";
      case /* String */ 23 :
        return "String";
      case /* Bytes */ 24 :
        return "Bytes";
    }
  };
  return {
    $$double: /* Double */ 0,
    $$float: /* Float */ 1,
    int32: /* Int32 */ 2,
    int64: /* Int64 */ 13,
    uint32: /* UInt32 */ 3,
    uint64: /* UInt64 */ 12,
    sint32: /* SInt32 */ 4,
    sint64: /* SInt64 */ 14,
    fixed32: /* Fixed32 */ 5,
    fixed64: /* Fixed64 */ 15,
    sfixed32: /* SFixed32 */ 6,
    sfixed64: /* SFixed64 */ 16,
    int32_int: /* Int32_int */ 7,
    int64_int: /* Int64_int */ 18,
    uint32_int: /* UInt32_int */ 8,
    uint64_int: /* UInt64_int */ 17,
    sint32_int: /* SInt32_int */ 9,
    sint64_int: /* SInt64_int */ 19,
    fixed32_int: /* Fixed32_int */ 10,
    fixed64_int: /* Fixed64_int */ 20,
    sfixed32_int: /* SFixed32_int */ 11,
    sfixed64_int: /* SFixed64_int */ 21,
    bool: /* Bool */ 22,
    string: /* String */ 23,
    bytes: /* Bytes */ 24,
    $$enum: $$enum,
    message: message,
    some: some,
    none: undefined,
    default_bytes: default_bytes,
    repeated: repeated,
    map: map,
    basic: basic,
    basic_req: basic_req,
    basic_opt: basic_opt,
    oneof: oneof,
    oneof_elem: oneof_elem,
    packed: /* Packed */ 0,
    not_packed: /* Not_packed */ 1,
    $caret$colon$colon: $caret$colon$colon,
    nil: /* Nil */ 0,
    nil_ext: nil_ext,
    show: show
  };
}

function $$enum(e) {
  return {
    TAG: /* Enum */ 0,
    _0: e
  };
}

function message(m) {
  return {
    TAG: /* Message */ 1,
    _0: m
  };
}

function some(v) {
  return Caml_option.some(v);
}

function default_bytes(v) {
  return Stdlib__Bytes.of_string(v);
}

function repeated(param) {
  return {
    TAG: /* Repeated */ 3,
    _0: param[0],
    _1: param[1],
    _2: param[2]
  };
}

function map(param) {
  return {
    TAG: /* Map */ 4,
    _0: param[0],
    _1: param[1]
  };
}

function basic(param) {
  return {
    TAG: /* Basic */ 0,
    _0: param[0],
    _1: param[1],
    _2: param[2]
  };
}

function basic_req(param) {
  return {
    TAG: /* Basic_req */ 2,
    _0: param[0],
    _1: param[1]
  };
}

function basic_opt(param) {
  return {
    TAG: /* Basic_opt */ 1,
    _0: param[0],
    _1: param[1]
  };
}

function oneof(s) {
  return {
    TAG: /* Oneof */ 5,
    _0: s
  };
}

function oneof_elem(param) {
  return {
    TAG: /* Oneof_elem */ 0,
    _0: param[0],
    _1: param[1],
    _2: param[2]
  };
}

function $caret$colon$colon(a, b) {
  return {
    TAG: /* Cons */ 1,
    _0: a,
    _1: b
  };
}

function nil_ext(extension_ranges) {
  return {
    TAG: /* Nil_ext */ 0,
    _0: extension_ranges
  };
}

function show(param) {
  if (!/* tag */ (typeof param === "number" || typeof param === "string")) {
    if (param.TAG === /* Enum */ 0) {
      return "Enum";
    } else {
      return "Message";
    }
  }
  switch (param) {
    case /* Double */ 0 :
      return "Double";
    case /* Float */ 1 :
      return "Float";
    case /* Int32 */ 2 :
      return "Int32";
    case /* UInt32 */ 3 :
      return "UInt32";
    case /* SInt32 */ 4 :
      return "SInt32";
    case /* Fixed32 */ 5 :
      return "Fixed32";
    case /* SFixed32 */ 6 :
      return "SFixed32";
    case /* Int32_int */ 7 :
      return "Int32_int";
    case /* UInt32_int */ 8 :
      return "UInt32_int";
    case /* SInt32_int */ 9 :
      return "SInt32_int";
    case /* Fixed32_int */ 10 :
      return "Fixed32_int";
    case /* SFixed32_int */ 11 :
      return "SFixed32_int";
    case /* UInt64 */ 12 :
      return "UInt64";
    case /* Int64 */ 13 :
      return "Int64";
    case /* SInt64 */ 14 :
      return "SInt64";
    case /* Fixed64 */ 15 :
      return "Fixed64";
    case /* SFixed64 */ 16 :
      return "SFixed64";
    case /* UInt64_int */ 17 :
      return "UInt64_int";
    case /* Int64_int */ 18 :
      return "Int64_int";
    case /* SInt64_int */ 19 :
      return "SInt64_int";
    case /* Fixed64_int */ 20 :
      return "Fixed64_int";
    case /* SFixed64_int */ 21 :
      return "SFixed64_int";
    case /* Bool */ 22 :
      return "Bool";
    case /* String */ 23 :
      return "String";
    case /* Bytes */ 24 :
      return "Bytes";
  }
}

function default_of_spec(Enum) {
  if (!/* tag */ (typeof Enum === "number" || typeof Enum === "string")) {
    if (Enum.TAG === /* Enum */ 0) {
      return Curry._1(Enum._0.from_int_exn, 0);
    } else {
      return 0;
    }
  }
  switch (Enum) {
    case /* Double */ 0 :
    case /* Float */ 1 :
      return 0.0;
    case /* Int32 */ 2 :
    case /* UInt32 */ 3 :
    case /* SInt32 */ 4 :
    case /* Fixed32 */ 5 :
    case /* SFixed32 */ 6 :
      return Stdlib__Int32.zero;
    case /* UInt64 */ 12 :
    case /* Int64 */ 13 :
    case /* SInt64 */ 14 :
    case /* Fixed64 */ 15 :
    case /* SFixed64 */ 16 :
      return Stdlib__Int64.zero;
    case /* Bool */ 22 :
      return false;
    case /* String */ 23 :
      return "";
    case /* Bytes */ 24 :
      return [];
    default:
      return 0;
  }
}

const $$double = /* Double */ 0;

const $$float = /* Float */ 1;

const int32 = /* Int32 */ 2;

const int64 = /* Int64 */ 13;

const uint32 = /* UInt32 */ 3;

const uint64 = /* UInt64 */ 12;

const sint32 = /* SInt32 */ 4;

const sint64 = /* SInt64 */ 14;

const fixed32 = /* Fixed32 */ 5;

const fixed64 = /* Fixed64 */ 15;

const sfixed32 = /* SFixed32 */ 6;

const sfixed64 = /* SFixed64 */ 16;

const int32_int = /* Int32_int */ 7;

const int64_int = /* Int64_int */ 18;

const uint32_int = /* UInt32_int */ 8;

const uint64_int = /* UInt64_int */ 17;

const sint32_int = /* SInt32_int */ 9;

const sint64_int = /* SInt64_int */ 19;

const fixed32_int = /* Fixed32_int */ 10;

const fixed64_int = /* Fixed64_int */ 20;

const sfixed32_int = /* SFixed32_int */ 11;

const sfixed64_int = /* SFixed64_int */ 21;

const bool = /* Bool */ 22;

const string = /* String */ 23;

const bytes = /* Bytes */ 24;

let none;

const packed = /* Packed */ 0;

const not_packed = /* Not_packed */ 1;

const nil = /* Nil */ 0;

export {
  Make,
  $$double,
  $$float,
  int32,
  int64,
  uint32,
  uint64,
  sint32,
  sint64,
  fixed32,
  fixed64,
  sfixed32,
  sfixed64,
  int32_int,
  int64_int,
  uint32_int,
  uint64_int,
  sint32_int,
  sint64_int,
  fixed32_int,
  fixed64_int,
  sfixed32_int,
  sfixed64_int,
  bool,
  string,
  bytes,
  $$enum,
  message,
  some,
  none,
  default_bytes,
  repeated,
  map,
  basic,
  basic_req,
  basic_opt,
  oneof,
  oneof_elem,
  packed,
  not_packed,
  $caret$colon$colon,
  nil,
  nil_ext,
  show,
  default_of_spec,
}
/* Stdlib__Int32 Not a pure module */
